var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrafta = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 24",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_crafta"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F79421",
  d: "M8.6 20.049c-1 0-3.2-.3-4.5-1.7-1.1-1.1-2.2-2.6-2.3-4.2 0-.7.1-2.3 1.1-1.6.5.4.6 1.8 1 2.7.9 1.8 2.2 2.5 4.5 2.5 2 0 3.4-1.6 4.1-3.2s1.8-1.7 2.4-.9c.5.8-1.8 6.2-6.3 6.4m4.5-14.4c1.2 1.2 2.9 2.1 2.3 3.7-.7 1.9-2-.4-3.2-2-1.1-1.5-2.7-2.5-5.1-1.4-2 .7-3.1 3.2-4.1 4.4-.7.7-1 1.3-2 1.3-.8 0-1.2-1.1-.9-1.7.4-1 1.9-2.2 2.6-2.8.8-.6 2.7-2.7 3.5-3.2 1.9-1.4 5.3.1 6.9 1.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CE7529",
  d: "M11.2 8.749c0 .5.1 1.1-.3 1.5-.3.4-1.7.6-1.7-.1-.1-1.3-1.9-1.3-2.4-.4-1.6 2.9 1.2 4.9 2.4 3.4 1-1.3 2.9-.6 1.8 1.3-.9 1.5-3 1.8-4.5 1s-1.9-2.6-1.8-4.2c.2-1.7 1.3-3.5 3-4.1 1.4-.5 3.5 0 3.5 1.6.1.8 0-.4 0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9AA4C",
  d: "M15.6 19.149c0 1.8-2.2 3.1-3.8 4.1-1.9 1-5.7 1.1-7.3-.4-.5-.5-1.4-1.5-.4-2.1.5-.3 1.9.9 3.3 1.1 1.9.2 3.5-.4 4.9-1.3.5-.4 3.2-3.2 3.3-1.4 0 .9 0-.6 0 0M6.7.349c1.9-.5 3-.4 4.8 0 1 .3 2.8 1.4 1.6 2.6-.8.8-2.1-.9-3.5-1-1.3-.2-2.5-.1-3.6.4-1.4.7-2.2 1.3-3.1 2.5-.7.8-1.9 2.6-2.2 1.6-.6-1.5 2.9-5.3 6-6.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79421",
  d: "M16 6.449c-.7-.2-2.3-1.9-1.9-3.2.7-1.8 2.2 1.2 2.2 2 .1.2.4 1.4-.3 1.2m-13.7 14c-.7.3-2.5-3.2-2-3.7 1.1-1.2 2 1.5 2.3 2.4.2.8 0 1.2-.3 1.3m14-6.5c.6-.9 1.3-.8 1.4-.2 0 1.1-1.7 4.4-2.1 2.5-.2-.7.3-1.6.7-2.3"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrafta);
export default ForwardRef;